import { getTableColumns } from "@/pages/consumption/view/billing-details/view/desktop-volume-detail/config/table-columns";

const columns = getTableColumns();
export function useTableColumns() {
  return { columns };
}
